<template>
  <div>
    <template v-if="!$route.meta.allowAnonymous">
      <v-app id="inspire">
        <div class="app-container">
          <navigation :toggle="drawer"/>
          <v-main>
            <toolbar @toggleNavigationBar="drawer = !drawer"/>
            <breadcrumbs />
            <router-view/>
<!--            <page-footer />-->
          </v-main>
        </div>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import vuetify from './config/vuetify';

export default {
  name: 'App',
  vuetify,
  data() {
    return {
      drawer: true
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue